import React, { FunctionComponent, lazy, Suspense } from 'react';

import { FallbackSection } from '../fallback';

const DiagnosticsSection = lazy(() => import('./section'));

export const SuspendedDiagnostics: FunctionComponent = () => (
    <Suspense fallback={<FallbackSection />}>
        <DiagnosticsSection />
    </Suspense>
);
